import { DASHBOARDROUTE, DASHBOARDTITLE } from '../views/dashboard/dashboard';

export class DashboardRouterStates {
    /** @ngInject */
    constructor($stateProvider) {
        this.$stateProvider = $stateProvider;
    }

    defineStates() {
        this.$stateProvider.state(DASHBOARDROUTE, {
            url: '/dashboard',
            controller: 'DashBoardController',
            controllerAs: 'vm',
            params: {
                pageTitle: DASHBOARDTITLE
            }
        });
    }
}
